import { Container } from './checkbox-button-group.styled';
import CheckboxItem from './checkbox-item/checkbox-item.component';

const CheckboxButtonGroupContainer = <T, >({ items, selectedItems, clickHandler }: CheckboxButtonGroupContainerProps<T>): JSX.Element => {
  return (
    <Container>
      {
        items.map(({
          id, title, description, Icon,
        }) => (
          <CheckboxItem
            key={ `checkbox_button_group_container_item_${id}` }
            id={ id }
            onClick={ clickHandler }
            title={ title }
            description={ description }
            Icon={ Icon }
            selected={ selectedItems.has(id) }
          />
        ))
      }
    </Container>
  );
};

export default CheckboxButtonGroupContainer;
